import * as types from "../actions/types"

const initialState = {
  loading: false,
  error: null,
  dashboard: null,
  dashboardTimeseries: { days: null, account_id: null, data: [] },
  dashboardAccountsHealth: [],
  dashboardCampaignsSummary: [],
  accounts: [],
  currentAccount: null,
  icps: [],
  currentICP: null,
  leads: { items: [], total: 0, page: 1, page_size: 25, total_pages: 0 },
  currentLead: null,
  imports: [],
  campaigns: { items: [], total: 0, page: 1, page_size: 25, total_pages: 0 },
  currentCampaign: null,
  campaignStats: null,
  campaignLeads: { items: [], total: 0, page: 1, page_size: 25 },
  steps: [],
  conversations: { items: [], total: 0, page: 1, page_size: 25, total_pages: 0 },
  currentConversation: null,
  messages: [],
  queue: { items: [], total: 0, page: 1, page_size: 50 },
  actionLog: { items: [], total: 0, page: 1, page_size: 50 },
}

const linkedinOutreachReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LI_SET_LOADING:
      return { ...state, loading: action.payload }
    case types.LI_SET_ERROR:
      return { ...state, error: action.payload }
    case types.LI_SET_DASHBOARD:
      return { ...state, dashboard: action.payload }
    case types.LI_SET_DASHBOARD_TIMESERIES:
      return { ...state, dashboardTimeseries: action.payload }
    case types.LI_SET_DASHBOARD_ACCOUNTS_HEALTH:
      return { ...state, dashboardAccountsHealth: action.payload }
    case types.LI_SET_DASHBOARD_CAMPAIGNS_SUMMARY:
      return { ...state, dashboardCampaignsSummary: action.payload }
    case types.LI_SET_ACCOUNTS:
      return { ...state, accounts: action.payload }
    case types.LI_SET_CURRENT_ACCOUNT:
      return { ...state, currentAccount: action.payload }
    case types.LI_SET_ICPS:
      return { ...state, icps: action.payload }
    case types.LI_SET_CURRENT_ICP:
      return { ...state, currentICP: action.payload }
    case types.LI_SET_LEADS:
      return { ...state, leads: action.payload }
    case types.LI_SET_CURRENT_LEAD:
      return { ...state, currentLead: action.payload }
    case types.LI_SET_IMPORTS:
      return { ...state, imports: action.payload }
    case types.LI_SET_CAMPAIGNS:
      return { ...state, campaigns: action.payload }
    case types.LI_SET_CURRENT_CAMPAIGN:
      return { ...state, currentCampaign: action.payload }
    case types.LI_SET_CAMPAIGN_STATS:
      return { ...state, campaignStats: action.payload }
    case types.LI_SET_CAMPAIGN_LEADS:
      return { ...state, campaignLeads: action.payload }
    case types.LI_SET_STEPS:
      return { ...state, steps: action.payload }
    case types.LI_SET_CONVERSATIONS:
      return { ...state, conversations: action.payload }
    case types.LI_SET_CURRENT_CONVERSATION:
      return { ...state, currentConversation: action.payload }
    case types.LI_SET_MESSAGES:
      return { ...state, messages: action.payload }
    case types.LI_SET_QUEUE:
      return { ...state, queue: action.payload }
    case types.LI_SET_ACTION_LOG:
      return { ...state, actionLog: action.payload }
    default:
      return state
  }
}

export default linkedinOutreachReducer
